"use client"

import { useState } from "react"
import { Email, MenuId } from "./types"
import { FOLDER_LABELS, EMAILS_BY_FOLDER } from "./data"
import TitleBar from "./TitleBar"
import FolderMenu from "./FolderMenu"
import EmailList from "./EmailList"
import EmailView from "./EmailView"
import ChatRoom from "./chat/ChatRoom"

type TrashMailClientProps = {
	newEzineEmails?: Email[]
}

export default function TrashMailClient({ newEzineEmails = [] }: TrashMailClientProps) {
	const [view, setView] = useState<MenuId>("inbox")
	const [selectedId, setSelectedId] = useState<string | null>(null)

	const emails =
		view === "chat"
			? []
			: view === "inbox"
				? [...newEzineEmails, ...EMAILS_BY_FOLDER.inbox]
				: EMAILS_BY_FOLDER[view]
	const selectedEmail = emails.find((e) => e.id === selectedId) ?? null

	const handleSelectView = (nextView: MenuId) => {
		setView(nextView)
		setSelectedId(null)
	}

	return (
		<div
			className="
				w-full h-full
				grid grid-rows-[auto_1fr]
				bg-[#060010]
				font-sans
			"
		>
			<TitleBar />
			<div className="flex min-h-0 p-1 gap-1 max-sm:portrait:flex-col">
				<FolderMenu selected={view} onSelect={handleSelectView} />
				<div className="flex-1 min-w-0 flex flex-col gap-1 min-h-0">
					{view === "chat" ? (
						<ChatRoom />
					) : selectedEmail ? (
						<EmailView email={selectedEmail} onBack={() => setSelectedId(null)} />
					) : (
						<EmailList
							title={FOLDER_LABELS[view]}
							emails={emails}
							selectedId={selectedId}
							onSelect={setSelectedId}
						/>
					)}
				</div>
			</div>
		</div>
	)
}
